export default function IconFlashlight( { isTorch } ) {
	return isTorch ? (
		<>
			<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
				<g>
					<path d="M0 0h24v24H0z" fill="none" />
					<path
						d="M13 9h8L11 24v-9H4l9-15v9zm-2 2V7.22L7.532 13H13v4.394L17.263 11H11z"
						fillRule="nonzero"
						fill="white"
					/>
				</g>
			</svg>
			<span>Apagar flash</span>
		</>
	) : (
		<>
			<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
				<g>
					<path d="M0 0h24v24H0z" fill="none" />
					<path d="M13 10h7l-9 13v-9H4l9-13z" fill="white" />
				</g>
			</svg>
			<span>Encender flash</span>
		</>
	);
}
